export default __webpack_public_path__ + "static/media/10_Nine.b6f90896.mp3";